import { Col, Row } from "react-bootstrap";
import React, { useCallback, useRef, useState } from "react";
import Image from "next/image";
import { parseHtml, toWebp } from "../../../utils/common";
import styles from "./style.module.scss";

const CoreServiceWeb = ({ block }) => {
    const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL;

    const listRef = useRef(null);
    const cardRefs = useRef([])
    const tabsContainerRef = useRef(null);

    const [centeredIndex, setCenteredIndex] = useState(0);

    const scrollToCenter = useCallback((element) => {
        const { offsetLeft, offsetWidth } = element;
        const { offsetWidth: containerWidth } = listRef.current;
        const centerPosition =
            offsetLeft - containerWidth / 2 + offsetWidth / 2;

        listRef.current.scrollTo({
            left: centerPosition,
            behavior: "smooth",
        });
    }, []);

    const handleClick = (event, index) => {
        scrollToCenter(event.currentTarget);
        setCenteredIndex(index === centeredIndex ? null : index);

        if (cardRefs.current[index] && tabsContainerRef.current) {
            const tabsHeight = tabsContainerRef.current.offsetHeight + 200;
            const cardTop = cardRefs.current[index].offsetTop;
            const scrollPosition = cardTop - tabsHeight;

            window.scrollTo({
                top: scrollPosition,
                behavior: 'smooth'
            });
        }
    };

    return (
        <>

            <div className={styles["core-sticky-heading"]}>
                <div className={styles["core-service-heading"]}>
                    <h2 className="text-black">{block?.title}</h2>
                    <p className="font-medium text-light-black">{block?.display_title}</p>

                </div>
                <div className={`${styles["core-service-links"]} ${styles["desktop-only"]}`} ref={tabsContainerRef}>
                    <ul className={styles.keypointList} ref={listRef}>
                        {block?.Keypoint?.map((keypoint, index) => (
                            <>
                                <li
                                    key={index}
                                    className={`border-2 border-color ${styles.keypointItem
                                        } ${index === centeredIndex
                                            ? `bg-primary-gradient text-white ${styles.active}`
                                            : "bg-white"
                                        }`}
                                    onClick={(e) =>
                                        handleClick(e, index)
                                    }
                                >
                                    <span
                                         className={`${styles.keypointText} text-light-black`}
                                    >
                                        {keypoint?.display_title}
                                    </span>
                                </li>
                            </>
                        ))}
                    </ul>
                </div>
            </div>


            {block?.Keypoint?.map((keypoint, index) => (
                <>
                    <div className={`${styles["core-service-card"]} border-color border-2 bg-white`} key={index} ref={el => cardRefs.current[index] = el}>
                        <Row>
                            <Col lg={8} sm={12}>
                                <div
                                    className={
                                        styles[
                                        "core-service-card-content"
                                        ]
                                    }
                                >
                                    <h4 className="h4 text-black font-semibold">{keypoint?.title}</h4>
                                    <p className="text-black font-regular">
                                        {parseHtml(
                                            keypoint?.description
                                        )}
                                    </p>
                                </div>
                                <div
                                    className={
                                        styles[
                                        "core-service-card-features"
                                        ]
                                    }
                                >
                                    <h6 className="text-small font-semibold text-black">
                                        {keypoint?.features_title
                                            ? keypoint?.features_title
                                            : "Core Service"}
                                    </h6>

                                    <div
                                        className={
                                            styles["core-feature-items"]
                                        }
                                    >
                                        {keypoint?.points?.map(
                                            (point, index) => (
                                                <>
                                                    <p key={index} className="text-ex-small  font-regular text-primary">
                                                        {point.title}
                                                    </p>
                                                </>
                                            )
                                        )}
                                    </div>
                                </div>
                            </Col>
                            <Col lg={4} sm={12}>
                                <div
                                    className={` ${styles["core-service-card-image"]}`}
                                >
                                    {keypoint?.image?.data && (
                                        <Image
                                            height={326}
                                            width={421}
                                            quality={100}
                                            loading="lazy"
                                            alt={
                                                keypoint?.image?.data
                                                    ?.attributes
                                                    ?.name || "Image"
                                            }
                                            src={
                                                keypoint?.image?.data
                                                    ?.attributes?.url
                                                    ? toWebp(
                                                        `${baseUrl}${keypoint?.image?.data?.attributes?.url}`
                                                    )
                                                    : null
                                            }
                                        />
                                    )}
                                </div>
                            </Col>
                        </Row>
                    </div>
                </>
            ))}
        </>
    );
};

export default CoreServiceWeb;
